export const METRIC = 1;
export const IMPERIAL = 2;
